import React from 'react'
import GoogleAd from '../GoogleAd';

/**
 * Displays a single ad.
 * Props:
 *      type:   is the type of ad(web-leader-board, mobile-leader-board, skyscraper, in-feed-horizontal, etc)
 *      device: is (eg mobile, tablet, desktop).
 *      style:  is an object representing an in-line style that is merged with base style for given device. 
 *              Typically, the style passed to displayAd helper function are margin adjustments. 
 * Process:
 *      Initialize default style for each device type (the default style currently sets the border).
 *      The default style is merged with the style passed in the style prop and is used as the GoogleAd Style.
 *      The device name is used to define className used for the particular device. That className is used 
 *      for the GoogleAd wrapper. The className dictates whether to Google Ad would show on a mobile, tablet, or desktop.
 *      
 *      Render the GoogleAd component passing in the adType and the adStyle
 * Output:
 *      Display a GoogleAd component 
 *      The witdh and height are set witin the GoogleAd component itself based on the Ad Unit being displayed.
 *
 * */
export function displayAd (type, device, style) {

    // Set testMode
    let testMode = false;

    /* Initialize styles for each device in test mode*/
    let mobileStyle  = {border: '1px solid red'}
    let tabletStyle  = {border: '1px solid red'}
    let desktopStyle = {border: '1px solid red'}
    
    /* When test mode is off, remove border while in production mode */
    if (!testMode) {
        mobileStyle  = {border: 'none'}
        tabletStyle  = {border: 'none'}
        desktopStyle = {border: 'none'}
    }

    /* set up defaults if parameters missing */
    let adType = type ? type : "mobile-leader-board";   /* default to mobile-leader-board */
    let deviceType = device ? device : "desktop";

    let baseStyle = desktopStyle;    /* default to desktop Style */
    if (device === "mobile") {
        baseStyle = mobileStyle
    } else if (device === "tablet") {
        baseStyle = tabletStyle;
    }

    let adStyle    = style ? Object.assign(baseStyle, style) : baseStyle;

    return (
        <div className={`display-on-${deviceType}`}>
            <GoogleAd type={adType} adStyle={adStyle} />
        </div>
    )
}




// WEBPACK FOOTER //
// ./src/components/advertisements/helpers/displayAd.js